export class FleetPainTrends {
  DISCREPANCY_MONTH: string;
  WEIGHTED_COST: number;
  REV_DEPTS: number;
  WEIGHTED_COST_PER_DEPT: number;
  M2_COUNT: number;
  M2_DLY_CNL_RATE: number;
  PDIS_RATE_PER_10K_DEPTS: number;
  M2_DELAY_COUNT: number;
  M2_CANCEL_COUNT: number;
  M2_GREATER_30_MINS: number;
  DELAY_CANCEL_COST: number;
  SIG_EVENT_COST: number;
  ATB_QTY: number;
  DIV_QTY: number;
  RTO_QTY: number;
  IFSD_QTY: number;
  EMER_QTY: number;
  BTB_QTY: number;
  SWAP_QTY: number;
  PDIS_QTY: number;
  OOS_EVENTS: number;
  WDL_QTY: number;
  RDL_QTY: number;
  OOS_EVENT_MIN: number;
}
